import { utils } from 'xlsx'

import csvReport from './csvReport'

const isUpperCase = (string) => /^[A-Z]*$/.test(string.split(' ').join(''))
const formatData = (data, from, sort, intl) => {
  const formatter = csvReport[from]

  if (formatter) {
    return formatter(data, sort || {}, intl)
  }

  return data.map((row) =>
    Object.entries(row).reduce((result, [key, value]) => {
      const updatedValue = Array.isArray(value) ? value.join(',') : value

      return {
        ...result,
        [isUpperCase(key)
          ? key
          : key
              .match(/([A-Z]?[^A-Z]*)/g)
              .slice(0, -1)
              .join(' ')
              .toUpperCase()]: updatedValue,
      }
    }, {}),
  )
}

export const buildSheet = (rawData, from, sort, intl) => {
  const data = formatData(rawData, from, sort, intl)
  const ws = utils.json_to_sheet(data)
  const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
  const letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P'] // if more are needed add more

  // Assigned headers names in order (A1, B1, C1, ...)
  if (data?.length) {
    const headerKeys = Object.keys(data[0])
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < headerKeys.length; i++) {
      ws[`${letters[i]}1`].v = headerKeys[i] // value of header assigned
    }
  }

  return { ws, wb }
}

export const getCsvBlob = (data, from, sort, intl) => {
  const { ws } = buildSheet(data, from, sort, intl)

  return new Blob([utils.sheet_to_csv(ws)], { type: 'text/csv' })
}
